const handleUnauthorizedResponse = () => window.location.reload();

export default handleUnauthorizedResponse;
